import { createActions } from 'redux-actions';
import keyMirror from 'key-mirror';

export const constants = keyMirror({
    RESOURCES_REQUEST: null,
    RESOURCES_SUCCESS: null,
    RESOURCES_FAILURE: null,

    CATEGORIES_REQUEST: null,
    CATEGORIES_SUCCESS: null,
    CATEGORIES_FAILURE: null,

    REGISTER_RESOURCE_VIEW_REQUEST: null,

    OWN_RESOURCES_REQUEST: null,
    OWN_RESOURCES_SUCCESS: null,
    OWN_RESOURCES_FAILURE: null,

    CREATE_RESOURCE_REQUEST: null,
    CREATE_RESOURCE_SUCCESS: null,
    CREATE_RESOURCE_FAILURE: null,

    UPDATE_RESOURCE_REQUEST: null,
    UPDATE_RESOURCE_SUCCESS: null,
    UPDATE_RESOURCE_FAILURE: null,

    DELETE_RESOURCE_REQUEST: null,
    DELETE_RESOURCE_SUCCESS: null,
    DELETE_RESOURCE_FAILURE: null
});

export const {
    resourcesRequest,
    resourcesSuccess,
    resourcesFailure
} = createActions(
    constants.RESOURCES_REQUEST,
    constants.RESOURCES_SUCCESS,
    constants.RESOURCES_FAILURE
);

export const {
    categoriesRequest,
    categoriesSuccess,
    categoriesFailure
} = createActions(
    constants.CATEGORIES_REQUEST,
    constants.CATEGORIES_SUCCESS,
    constants.CATEGORIES_FAILURE
);

export const {
    registerResourceViewRequest
} = createActions(
    constants.REGISTER_RESOURCE_VIEW_REQUEST
);

// manage resources

export const {
    ownResourcesRequest,
    ownResourcesSuccess,
    ownResourcesFailure
} = createActions(
    constants.OWN_RESOURCES_REQUEST,
    constants.OWN_RESOURCES_SUCCESS,
    constants.OWN_RESOURCES_FAILURE
);

export const {
    createResourceRequest,
    createResourceSuccess,
    createResourceFailure
} = createActions(
    constants.CREATE_RESOURCE_REQUEST,
    constants.CREATE_RESOURCE_SUCCESS,
    constants.CREATE_RESOURCE_FAILURE
);

export const {
    updateResourceRequest,
    updateResourceSuccess,
    updateResourceFailure
} = createActions(
    constants.UPDATE_RESOURCE_REQUEST,
    constants.UPDATE_RESOURCE_SUCCESS,
    constants.UPDATE_RESOURCE_FAILURE
);

export const {
    deleteResourceRequest,
    deleteResourceSuccess,
    deleteResourceFailure
} = createActions(
    constants.DELETE_RESOURCE_REQUEST,
    constants.DELETE_RESOURCE_SUCCESS,
    constants.DELETE_RESOURCE_FAILURE
);



/** WEBPACK FOOTER **
 ** ./src/core/resources/resourcesActions.js
 **/